import { getuuid } from "../uuid";
import JSEncrypt from "jsencrypt";
import { getLPK } from "./fetchWasm";
import { dateCalibration, serverDate } from "./dateCalibration";

const K = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAxJ5ARicPBuuJ57o/bk51
ybz3DKFBxcw3Go6S9kWTZofSYcvjDuGtZzMZzW+vgwBp/a3Ip8H8W+a/8rBulxNt
cCOk/i6K5aKMpeQAslN+2rE8rFwMlOasPXvGqOpJVLLMk6uBNaqtxq90loYHYhAE`;

const getSign = async url => {
  const a = getuuid(6, 36);
  const p = getuuid(6, 36);
  const u = getuuid(6, 36);
  const timesTamp = (await serverDate()) + "";
  const DAY = dateCalibration(timesTamp, "day");
  const MONTH = dateCalibration(timesTamp, "month");
  const ttapList = [timesTamp.slice(0, DAY), timesTamp.slice(DAY)];
  const midTimesTamp = ttapList[0] + p + ttapList[1];
  const midttapList = MONTH !== 0 ? [midTimesTamp.slice(0, -MONTH), midTimesTamp.slice(-MONTH)] : [midTimesTamp, ""];
  const S = midttapList[0] + url + midttapList[1];
  const signer = new JSEncrypt();
  const KK = K + "\n" + (await getLPK());
  signer.setPublicKey(KK);
  const si = signer.encrypt(S);

  return {
    si,
    a,
    p,
    u
  };
};

export { getSign };
